import { render, staticRenderFns } from "./OnlineTeacherComments.vue?vue&type=template&id=c10a1ce0&"
import script from "./OnlineTeacherComments.vue?vue&type=script&lang=js&"
export * from "./OnlineTeacherComments.vue?vue&type=script&lang=js&"
import style0 from "./OnlineTeacherComments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports